<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <v-btn text x-small class='ml-0' color='primary' depressed
             @click='sensitiveFormData.id = null; sensitiveFormData.word = null; addSensitiveDialog = true'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiPlusCircleOutline }}</v-icon>
        <span class='ml-1'>新增</span>
      </v-btn>
      <v-btn text x-small class='ml-1' color='primary' depressed
             @click='searchAnalysisWord = null; sensitiveDataList = []; analysisDialog = true'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiGoogleAnalytics }}</v-icon>
        <span class='ml-1'>分析敏感词</span>
      </v-btn>
      <v-btn text x-small class='ml-1' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :height='tableHeight'
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='word' title='Word' :filters="[{ data: '' }]">
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
      <vxe-column field='legalFlag' title='Legal Flag'
                  :filters="[{ label: '启用', value: '0' },
                               { label: '停用', value: '1' },]">
        <template #default='{ row }'>
          <span v-show='row.legalFlag === true'>停用</span>
          <span v-show='row.legalFlag === false'>启用</span>
        </template>
      </vxe-column>
      <vxe-column title='Option' width='100' align='center'>
        <template #default='{ row }'>
          <v-btn color='primary' text class='mr-1' x-small @click='editSensitiveWord(row)'>
            <v-icon small>{{ icons.mdiPencil }}</v-icon>
          </v-btn>
          <v-btn color='primary' text x-small
                 @click='deleteSensitiveList.push(row); deleteSensitiveDialog = true'>
            <v-icon small>{{ icons.mdiDelete }}</v-icon>
          </v-btn>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
    <!--添加敏感词-->
    <v-dialog v-model='addSensitiveDialog' max-width='500px' persistent>
      <v-card>
        <v-card-title v-if='!sensitiveFormData.id'>保存</v-card-title>
        <v-card-title v-else>编辑</v-card-title>

        <v-form class='mt-3' ref='sensitiveForm'>
          <div style='margin: 0 auto 0 20px;'>
            <v-text-field
              label='Word'
              v-model='sensitiveFormData.word'
              :rules='[v => !!v]'
              required
              dense
              class='required'
            ></v-text-field>
            <p style='font-size: 15px; padding: 0'>Legal Flag</p>
            <v-radio-group v-model='sensitiveFormData.legalFlag' dense row hide-detail>
              <v-radio label='True' :value='0'></v-radio>
              <v-radio label='False' :value='1'></v-radio>
            </v-radio-group>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color='primary' text small
                   @click='sensitiveFormData.word = null; sensitiveFormData.legalFlag = 0; addSensitiveDialog = false'>
              取消
            </v-btn>
            <v-btn small color='primary' @click='saveOrUpdateSensitiveWord'
                   :disabled='saveOrUpdateSensitiveWord_loading'>保存
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!--删除敏感词-->
    <v-dialog
      v-model='deleteSensitiveDialog'
      width='400'
      persistent
    >
      <v-card>
        <v-card-title class='text-h6 py-3'>
          删除
        </v-card-title>

        <v-card-text>
          您确定要删除此敏感词吗？
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color='primary'
            text
            small
            @click='deleteSensitiveList = []; deleteSensitiveDialog = false'
          >
            取消
          </v-btn>
          <v-btn
            color='primary'
            small
            @click='deleteDataFunc()'
            :loading='deleteLoading'
          >
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--敏感词分析-->
    <v-dialog
      v-model='analysisDialog'
      max-width='580'
      persistent
    >
      <v-card>
        <v-card-title class='text-h6 py-3'>
          分析敏感词
        </v-card-title>
        <div class='mt-2 mx-8 d-flex'>
          <v-text-field
            label='Word'
            v-model='searchAnalysisWord'
            placeholder='Please enter the sensitive word you want to verify'
            clearable
            dense
          />
          <v-btn
            color='primary'
            text
            :loading='searchAnalysisLoading'
            @click='searchAnalysisWordFunc'
          >
            <v-icon class='mr-1'>{{ icons.mdiClipboardTextSearch }}</v-icon>
            分析
          </v-btn>
        </div>

        <div class='mt-2 mx-8 font-weight-bold'
             style='display: flex; min-height: 120px; font-size: 14px'>
          <span class='mr-4' v-for='(item, index) in sensitiveDataList' :key='index'>
            {{ item }}
          </span>
          <span v-if='sensitiveDataList.length === 0'>暂无相关敏感词</span>
        </div>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color='primary'
            text
            small
            @click='sensitiveDataList = []; searchAnalysisWord = null; analysisDialog = false'
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  getSensitiveWordPageList,
  addSensitiveWord,
  updateSensitiveWord,
  deleteSensitiveWord,
  sensitiveAnalysis,
} from '../api/index'

import {
  mdiPencil,
  mdiDelete,
  mdiClipboardTextSearch,
  mdiPlusCircleOutline,
  mdiGoogleAnalytics,
  mdiRefresh,
} from '@mdi/js'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      searchParams: {
        legalFlagList: [],
        word: null,
      },
      addSensitiveDialog: false,
      sensitiveFormData: {
        word: null,
        legalFlag: 0,
        id: null,
      },
      saveOrUpdateSensitiveWord_loading: false,
      icons: {
        mdiPencil,
        mdiDelete,
        mdiClipboardTextSearch,
        mdiPlusCircleOutline,
        mdiGoogleAnalytics,
        mdiRefresh,
      },
      deleteSensitiveDialog: false,
      deleteSensitiveList: [],
      deleteLoading: false,
      analysisDialog: false,
      searchAnalysisWord: null,
      sensitiveDataList: [],
      searchAnalysisLoading: false,
      tableHeight: 0,
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    refresh() {
      this.pagerOption.pageNum = 1
      this.pagerOption.pageSize = 20
      this.getPageList()
    },
    getScreenHeight() {
      this.tableHeight = window.innerHeight - 64 - 50 - 50
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.word = null
      this.searchParams.legalFlagList = []
      filters.forEach(item => {
        if (item.property === 'legalFlag') {
          this.searchParams.legalFlagList = item.values
        } else if (item.property === 'word') {
          this.searchParams.word = item.datas[0]
        }
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    editSensitiveWord(row) {
      this.sensitiveFormData.id = row.id
      this.sensitiveFormData.word = row.word
      this.sensitiveFormData.legalFlag = row.legalFlag ? 1 : 0
      this.addSensitiveDialog = true
    },
    async searchAnalysisWordFunc() {
      if (!this.searchAnalysisWord) {
        return
      }
      this.searchAnalysisLoading = true
      const {
        data: {
          code,
          msg,
          data,
        },
      } = await sensitiveAnalysis({ word: this.searchAnalysisWord })
      if (code === 200) {
        this.sensitiveDataList = data
      }
      this.searchAnalysisLoading = false
    },
    async deleteDataFunc() {
      this.deleteLoading = true
      const { data: { code, msg } } = await deleteSensitiveWord(this.deleteSensitiveList)
      this.deleteSensitiveDialog = false
      if (code === 200) {
        this.$message.success('删除成功')
        this.getPageList()
      } else {
        this.$message.error(msg)
      }
      this.deleteLoading = false
    },
    async saveOrUpdateSensitiveWord() {
      if (this.$refs.sensitiveForm.validate()) {
        this.saveOrUpdateSensitiveWord_loading = true
        if (!this.sensitiveFormData.id) {
          const { data: { code, msg } } = await addSensitiveWord(this.sensitiveFormData)
          this.addSensitiveDialog = false
          if (code === 200) {
            this.$message.success('添加成功')
            this.getPageList()
          } else {
            this.$message.error(msg)
          }
        } else {
          const {
            data: {
              code,
              msg,
            },
          } = await updateSensitiveWord(this.sensitiveFormData)
          this.addSensitiveDialog = false
          if (code === 200) {
            this.$message.success('更新成功')
            this.getPageList()
          } else {
            this.$message.error(msg)
          }
        }
        this.saveOrUpdateSensitiveWord_loading = false
      }
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      const {
        data: {
          code,
          data,
        },
      } = await getSensitiveWordPageList({ ...this.pagerOption, ...this.searchParams })
      if (code === 200) {
        this.dataList = data.records
        this.pagerOption.totalData = data.total
      }
      this.tableLoading = false
    },
  },
}
</script>
